
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexTypeDialog extends SiteEntityDialog<IndexTypeRow, any> {
        protected getFormKey() { return IndexTypeForm.formKey; }
        protected getIdProperty() { return IndexTypeRow.idProperty; }
        protected getLocalTextPrefix() { return IndexTypeRow.localTextPrefix; }
        protected getNameProperty() { return IndexTypeRow.nameProperty; }
        protected getService() { return IndexTypeService.baseUrl; }
        protected getDeletePermission() { return IndexTypeRow.deletePermission; }
        protected getInsertPermission() { return IndexTypeRow.insertPermission; }
        protected getUpdatePermission() { return IndexTypeRow.updatePermission; }

        protected form = new IndexTypeForm(this.idPrefix);

    }
}